import { z } from 'zod';
// ============================================================
// AssetAttachment — image / document metadata for a FixedAsset.
// Binary lives in MinIO; this row holds the storage key + display fields.
// kind is derived from mimeType in the API (image/* => IMAGE, else DOCUMENT)
// but exposed here so clients can filter without re-deriving.
// ============================================================
export const AssetAttachmentKindSchema = z.enum(['IMAGE', 'DOCUMENT']);
export const AssetAttachmentSchema = z.object({
    id: z.uuid(),
    assetId: z.uuid(),
    kind: AssetAttachmentKindSchema,
    filename: z.string(),
    mimeType: z.string(),
    sizeBytes: z.number().int().nonnegative(),
    storageKey: z.string(),
    caption: z.string().nullable().optional(),
    uploadedBy: z.string().nullable().optional(),
    uploadedAt: z.coerce.date(),
});
// Response shape for the presigned-URL endpoint.
export const AssetAttachmentDownloadUrlSchema = z.object({
    url: z.string(),
    expiresAt: z.coerce.date(),
});
//# sourceMappingURL=asset-attachment.js.map